import React, { useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import { useLocation, useNavigate } from "react-router-dom";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const query = new URLSearchParams(useLocation().search);
  const token = query.get("token");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.post("/api/users/reset-password", {
        token,
        newPassword: password
      });

      // Handle success response
      if (response.status === 200) {
        setMessage("Password has been reset successfully.");

        // Redirect to home after a successful password reset
        setTimeout(() => {
          navigate("/");
        }, 2000); // Redirect after 2 seconds
      }
    } catch (error) {
      // Display error message based on the backend response
      if (error.response && error.response.status === 400) {
        setMessage("Invalid token.");
      } else if (error.response && error.response.status === 404) {
        setMessage("User not found.");
      } else {
        setMessage("Error resetting password.");
      }
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <h3>Reset Password</h3>
          {message && <div className="alert alert-info">{message}</div>}
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">New Password</label>
              <input
                type="password"
                className="form-control"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary">Reset Password</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
